import renderModelAndName from './render-model';

export default renderModelAndName;
